export default function propTypeEmptyString(props, propName, componentName) {
  const propValue = props[propName];

  if (typeof propValue !== 'string' || propValue === 'undefined') {
    return new Error(
      `${componentName} '${propName}' is required and must be a string`
    );
  }
  if (propValue === '') {
    return new Error(`${componentName} '${propName}' prop cannot be empty`);
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/utils/customPropTypesCheck.js